'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (window.googletag) {
    return window.googletag;
  }

  var googletag = window.googletag = {
    cmd: [],
    slots: {}
  };

  googletag.cmd.push(function () {
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().enableAsyncRendering();
    googletag.pubads().disableInitialLoad();
    googletag.enableServices();
    googletag.pubads().setTargeting('allowtransparency', '');
  });

  (function () {
    var gads = document.createElement('script');

    gads.async = true;
    gads.type = 'text/javascript';
    gads.src = 'https://www.googletagservices.com/tag/js/gpt.js';

    var head = document.getElementsByTagName('head')[0];

    head.appendChild(gads);
  })();

  return googletag;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/build/GooglePublisherTag/initGpt.js
 ** module id = 863
 ** module chunks = 0
 **/